import { partnerApi } from '../../api';
import * as UserActions from '../user/actions';




export async function searchPartnerJson(token, id) {
  const apiResponse = await partnerApi.getPartner(token,id);
  const respJson = await apiResponse.json();
  let obj = {};
  if (apiResponse.status === 200) {
    obj['state'] = true;
    obj['data'] = respJson;
  } else {
    obj['state'] = false;
    obj['msg'] = respJson;
  }
  return obj;

}

export function searchPartnersJson(token, page, formdata) {
  return async dispatch => {
    try {
      dispatch({ type: 'RESET_PARTNERS' });
      dispatch({ type: 'LOADING_PARTNERS', loading: true, error: '' });

      const apiResponse = await partnerApi.searchPartners(token, page, formdata);
      const respJson = await apiResponse.json();
      if (apiResponse.status === 200) {
        let obj = {};
        obj['max_num_pages'] = respJson['max_num_pages'];
        obj['currentpage'] = respJson['currentpage'];
        obj['selected'] = respJson['selected'];
        obj['result'] = respJson['data'];
      
        dispatch({ type: 'SET_PARTNERS', data:obj });
        dispatch({ type: 'LOADING_PARTNERS', loading: false, error: '' });

      } else if (apiResponse.status === 403) {
        dispatch({ type: 'LOADING_PARTNERS', loading: false, error: '' });
        UserActions.logoutWithDispatch(dispatch);

      }else{
        dispatch({ type: 'LOADING_PARTNERS', loading: false, error: respJson });
      }
    } catch (error) {
      dispatch({ type: 'LOADING_PARTNERS', loading: false, error: error });
    }

  }
}



